export enum ErrorType {
  Warning = "warning",
}

export interface ErrorMessage {
  field: string;
  message: string;
  type: string;
}

export interface ErrorResponse {
  errors: ErrorMessage[];
  statusCode: number;
}
